import { CommonModule, Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { IconsModule } from '../../icons/icons.module';
import {
  NavigationItem,
  TabNavigationComponent,
} from '../tab-navigation/tab-navigation.component';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.css'],
  standalone: true,
  imports: [CommonModule, IconsModule, TabNavigationComponent],
})
export class BaseLayoutComponent {
  @Input()
  showBackButton = false;

  @Input()
  navigationItems?: NavigationItem[];

  @Input()
  backUrl?: string;

  @Input()
  headerBackground: string = '';

  @Input()
  overrideNavigation: boolean = false;

  constructor(
    private readonly location: Location,
    private readonly router: Router
  ) {}

  goBack() {
    if (this.backUrl) {
      this.router.navigateByUrl(this.backUrl);
    } else {
      this.location.back();
    }
  }
}
